class editGiftCardModal extends HTMLElement {
  constructor() {
    super();
    this.iconClose = this.querySelector('.icon-close');
    this.selectedAmountEl = this.querySelector('.gift-card-modal__selected-amount');
    this.nameEl =  this.querySelector('#gift-card-modal-name');
    this.emailEl = this.querySelector('#gift-card-modal-email');
    this.dateEl = this.querySelector('#gift-card-modal-date');
    this.messageEl = this.querySelector('#gift-card-modal-message');
    this.saveButton = this.querySelector('.gift-card-modal-save');

    // Close
    this.iconClose.addEventListener('click', this.closeGiftCardModal.bind(this));
    this.addEventListener('click', function(e) {if (e.target === this) this.closeGiftCardModal()});
    window.addEventListener('keydown', e => {if (e.key === 'Escape') this.closeGiftCardModal()});

    // Save
    this.saveButton.addEventListener('click', this.onSaveButtonClick.bind(this));
  }

  onGiftCardEditClick(giftCardLineItem) {
    // 1. Get values from the cart
    const selectedAmount = giftCardLineItem.querySelector('.variant-title')?.innerText;
    const name = giftCardLineItem.querySelector('.cart-item__property[data-property="Recipient name"] dd')?.innerText;
    const email = giftCardLineItem.querySelector('.cart-item__property[data-property="Recipient email"] dd')?.innerText;
    const date = giftCardLineItem.querySelector('.cart-item__property[data-property="Send on"] dd')?.innerText;
    const message = giftCardLineItem.querySelector('.cart-item__property[data-property="Message"] dd')?.innerText;
    const lineItemIndex = giftCardLineItem.id.split("CartDrawer-Item-")[1];

    // 2. Set values to the edit gift card modal
    this.selectedAmountEl.textContent = selectedAmount;
    this.nameEl.value = name;
    this.emailEl.value = email;
    this.dateEl.value = date;
    if (message) this.messageEl.value = message;
    this.saveButton.dataset.index = lineItemIndex;

    // 3. Open edit gift card modal
    this.openGiftCardModal();
  }

  openGiftCardModal() {
    this.classList.remove('hidden');
    document.body.classList.add('gift-card-modal-opened');
  }

  closeGiftCardModal() {
    this.classList.add('hidden');
    document.body.classList.remove('gift-card-modal-opened');
    this.clearData();
  }

  clearData() {
    this.selectedAmountEl.textContent = '';
    this.nameEl.value = '';
    this.emailEl.value = '';
    this.dateEl.value = '';
    this.messageEl.value = '';
    this.saveButton.dataset.index = '';
  }

  onSaveButtonClick(e) {
    const form = this.querySelector('.gift-card-modal__form');

    e.preventDefault();

    if (form.checkValidity()) {
      // 1. Properties object (Edited data)
      let properties = {
        "Recipient name": this.nameEl.value,
        "Recipient email": this.emailEl.value,
        "Send on": this.dateEl.value,
        "Message": this.messageEl.value,
        "__shopify_send_gift_card_to_recipient": true
      }

      // 2. Update cart
      const cartItems = document.querySelector("cart-items") || document.querySelector("cart-drawer-items");
      cartItems.updateProperties(this.saveButton.dataset.index, properties);


      // 3. Close edit gift card modal
      this.closeGiftCardModal();
    } else {
      form.reportValidity();
    }
  }
}

customElements.define('edit-gift-card-modal', editGiftCardModal);

class EditGiftCardButton extends HTMLElement {
  constructor() {
    super();
    this.editGiftCardModal = document.querySelector('edit-gift-card-modal');
    this.addEventListener('click', this.onclick);
  }

  onclick() {
    this.editGiftCardModal.onGiftCardEditClick(this.closest('.cart-item'));
  }
}

customElements.define('edit-gift-card-button', EditGiftCardButton);